export const UNAUTHORIZED_ERROR = "UnauthorizedError";
export const COURSE_VALIDATION_ERROR = "CourseValidationError";

export function UnathorizedError(msg) {
    const err = Error(msg);
    err.name = UNAUTHORIZED_ERROR;
    return err;
}


export function CourseValidationError(msg) {
    const err = Error(msg);
    err.name = COURSE_VALIDATION_ERROR;
    return err;
}